export const transparentizeHSL = (hsl: string, alpha: number) => {
  const match = hsl.match(/^hsl\(\s*([0-9.]+)\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*\)$/);

  if (match) {
    const [_, h, s, l] = match;

    return `hsla(${h}, ${s}%, ${l}%, ${alpha})`;
  }

  return hsl;
};
